import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import { FormFieldComponentProps } from "../../../lib/types/types";
import { FormFieldText } from "../FormFieldText/FormFieldText";
import { useFlag } from "../../FeatureFlags/hooks";

interface PassedProps {
  explanation?: string | JSX.Element;
}

export const CVECNumber = ({
  value,
  isErrored,
  onChange,
  intl,
  explanation,
  placeholder = "",
  isRequired = false,
}: FormFieldComponentProps & PassedProps) => {
  // #region include-cvec-field-france-student
  const showCvecInputVariation = useFlag("include-cvec-field-france-student");

  const getDefaultExplanation = () =>
    showCvecInputVariation === "labeled-optional" ? (
      <FormattedHTMLMessage
        id="cvecNumberExplanation"
        defaultMessage="Optional - Add your CVEC number to increase your chances of being verified instantly."
      />
    ) : (
      <FormattedHTMLMessage
        id="_EXPERIMENTAL.cvecNumberExplanation"
        defaultMessage="Add your CVEC number to increase your chances of being verified instantly."
      />
    );
  // #endregion include-cvec-field-france-student

  const isFieldHidden = getFieldConfigByFieldId("cvecNumber")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="cvecNumber"
      value={value}
      onChange={onChange}
      placeholder={
        placeholder ||
        intl.formatHTMLMessage({
          id: "cvecNumberPlaceholder",
          defaultMessage: "CVEC certificate number",
        })
      }
      label={<FormattedHTMLMessage id="cvecNumber" defaultMessage="CVEC certificate number" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidCvecNumber"
            defaultMessage="Invalid CVEC certificate number"
          />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      required={isRequired}
      explanation={explanation || getDefaultExplanation()}
    />
  );
};
export const CVECNumberComponent = injectIntl(CVECNumber);
